// Generated by `bazel run i18n`. Do not edit by hand.
import chatFlow_c7eb565d from "./en/src--flows--chat-flow.json";
import conditionTypes_94e507c8 from "./en/src--flows--return-flow--condition-types.json";
import returnFlow_8325a46a from "./en/src--flows--return-flow.json";
import conditions_d508e039 from "./en/src--flows--rules--conditions.json";
import rules_96f2a367 from "./en/src--flows--rules.json";
import flows_d0dd6e65 from "./en/src--flows.json";

export default Object.assign(
  {},
  chatFlow_c7eb565d,
  conditionTypes_94e507c8,
  returnFlow_8325a46a,
  conditions_d508e039,
  rules_96f2a367,
  flows_d0dd6e65,
);
